/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaStep from 'DesignSystem/TysiaStep/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/Step/Display/Content"
  
}) {
let stepsCurrentIndexValueData = fromData.useDataValue({ viewPath,
context: 'steps',
path: 'current_index',
})
let stepItemIndexValueData = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'index',
})
let aggregateData = fromAggregate.equals(stepsCurrentIndexValueData, stepItemIndexValueData)
let stepItemIndexValueData1 = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'index',
})
let constantData = 1
let aggregateData1 = fromAggregate.add(stepItemIndexValueData1, constantData)
let stepNameValueData = fromData.useDataFormat({ viewPath,
context: 'step',
path: 'name',
format: fromHelpers.getTitle,
})
let stepItemIsLastValueData = fromData.useDataValue({ viewPath,
context: 'step_item',
path: 'isLast',
})
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaStep
  viewPath={`${viewPath}/TysiaStep`}
 data="steps.current_index"
 data="step_item.index"
 aggregate="/Data/aggregate.js equals"
 selected={aggregateData}
 data="step_item.index"
 data={1}
 aggregate="/Data/aggregate.js add"
 step={aggregateData1}
 data="step.name"
 format="helpers.js getTitle"
 text={stepNameValueData}
 weight="medium"
 size="normal"
/>
<fromFlow.When is={!stepItemIsLastValueData}>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z1Yf8zk': dtColorsNeutral300,'--ml-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}